export default __webpack_public_path__ + "static/media/Logo.55447c46.png";